import React from 'react';
import { Link } from 'react-router-dom';

export default function PagoSuccess() {
  return (
    <div className="container">
      <h2>¡Gracias por tu pago!</h2>
      <p>Tu inscripción fue confirmada exitosamente.</p>
      <Link to="/">Volver al inicio</Link>
    </div>
  );
}
